var alignment_rtlignore_default = {
  "alignLeft": "ronly",
  "textWrapNowrap": "LePoH",
  "alignRight": "hh1w-",
  "alignCenter": "gfSDi",
  "sizeFullWidth": "m1EG6",
  "renderedInTable": "TdD2P",
  "sizeOriginal": "_9nse1",
  "sizeContent": "_2AFsd",
  "sizeSmall": "X7nTF",
  "sizeSmallCenter": "_1aR3B",
  "flex": "sRnUa",
  "LEFT": "VXjXk",
  "CENTER": "Ke2y0",
  "RIGHT": "I3F-n",
  "AUTO": "kuIFz",
  "JUSTIFY": "KSJjC"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
